export default __webpack_public_path__ + "static/hire_react_banner-ad0cd7bffaa94a1655eda0191fbcdf21.webp";